export default "__VITE_ASSET__3a599bee__"